import { render } from "./FileInput.vue?vue&type=template&id=2693a87c"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janvalenta/Documents/Projects/sites/somisale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__